import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';
import {
  NavegacaoDaPlataforma,
  type AreaDaPlataforma,
} from '@/features/plataforma/componentes/NavegacaoDaPlataforma';
import { rotaDaPlataforma } from '@/features/permissoes/guardas';

/** Área da plataforma: só o super-admin, com menu próprio (spec 003, CA-08; spec 014, CA-06). */
export const Route = createFileRoute('/_autenticado/plataforma')({
  ...rotaDaPlataforma('Plataforma'),
  component: Layout,
});

function Layout() {
  const caminho = useRouterState({ select: (s) => s.location.pathname });
  return (
    <>
      <NavegacaoDaPlataforma atual={caminho as AreaDaPlataforma} />
      <Outlet />
    </>
  );
}
